var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "background" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-container" },
      [
        _c("p", { staticClass: "description" }, [
          _vm._v(
            "アプリからの会員情報更新を許可するかを設定します。OFFの時はアプリから情報更新ができなくなります。"
          ),
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { "label-position": "top" },
          },
          [
            _c(
              "div",
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("個人情報"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._l(_vm.personalFields, function (field) {
                  return _c(
                    "el-row",
                    {
                      key: field.key,
                      staticClass: "field-row",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("span", { staticClass: "field-label" }, [
                          _vm._v(_vm._s(field.label)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "ON",
                              "inactive-text": "OFF",
                            },
                            model: {
                              value: _vm.form[field.key],
                              callback: function ($$v) {
                                _vm.$set(_vm.form, field.key, $$v)
                              },
                              expression: "form[field.key]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("hr", { staticClass: "divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("会社情報"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._l(_vm.companyFields, function (field) {
                  return _c(
                    "el-row",
                    {
                      key: field.key,
                      staticClass: "field-row",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("span", { staticClass: "field-label" }, [
                          _vm._v(_vm._s(field.label)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "ON",
                              "inactive-text": "OFF",
                            },
                            model: {
                              value: _vm.form[field.key],
                              callback: function ($$v) {
                                _vm.$set(_vm.form, field.key, $$v)
                              },
                              expression: "form[field.key]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "action-button",
                        attrs: { type: "primary", loading: _vm.saving },
                        on: { click: _vm.save },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h2", { staticClass: "page-title" }, [_vm._v("プロフィール変更設定")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }